import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { PasswordPage } from '../pages/password/password';
import { BranchLocatorPage } from '../pages/branch-locator/branch-locator';
import { CalculatorPage } from '../pages/calculator/calculator';
import { FaqPage } from '../pages/faq/faq';
import { IntrestRateMovementPage } from '../pages/intrest-rate-movement/intrest-rate-movement';
import { OffersPage } from '../pages/offers/offers';
import { OtherProductPage } from '../pages/other-product/other-product';
import { PmayPage } from '../pages/pmay/pmay';
import { ReferAFriendPage } from '../pages/refer-a-friend/refer-a-friend';
import { PropertyDocumentListPage } from '../pages/property-document-list/property-document-list';
import { PropertyDocumentPickupPage } from '../pages/property-document-pickup/property-document-pickup';
import { PropertyDocumentChecklistPage } from '../pages/property-document-checklist/property-document-checklist';


import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CommonProvider } from '../providers/common/common';
import { GenericFormValidationProvider } from '../providers/common/form-validation';

// import { HttpClientModule } from '@angular/common/http'
import { OtpPage } from '../pages/otp/otp';
import { ForgotMobileNumberPage } from '../pages/forgot-mobile-number/forgot-mobile-number';
import { CreateNewPasswordPage } from '../pages/create-new-password/create-new-password';
import { SetNewPasswordPage } from '../pages/set-new-password/set-new-password';
import { DashBoardPage } from '../pages/dash-board/dash-board';
import { CommingSoonPage } from '../pages/comming-soon/comming-soon';
import { AccountSummaryPage } from '../pages/account-summary/account-summary';
import { PaymentsPage } from '../pages/payments/payments';
import { ServiceRequestPage } from '../pages/service-request/service-request';
import { RaisedIssuesPage } from '../pages/raised-issues/raised-issues';
import { PersonalDetailsPage } from '../pages/personal-details/personal-details';
import { InvestRateHistoryPage } from '../pages/invest-rate-history/invest-rate-history';
import { EmiPmiPaymentsPage } from '../pages/emi-pmi-payments/emi-pmi-payments';
import { OthersPaymentsPage } from '../pages/others-payments/others-payments';
import {NewservicerequestPage} from '../pages/newservicerequest/newservicerequest'
import { ServicehistoryPage } from '../pages/servicehistory/servicehistory';
import { RaisedservicehistoryPage } from '../pages/raisedservicehistory/raisedservicehistory';
import { UpdateinfoloadingsrPage } from '../pages/updateinfoloadingsr/updateinfoloadingsr';
import { DocumentstatementPage } from '../pages/documentstatement/documentstatement';
import {UpdatepersonalPage} from '../pages/updatepersonal/updatepersonal'
import {UpdatepersonaleditPage} from '../pages/updatepersonaledit/updatepersonaledit'
import {UpdatecontactPage} from '../pages/updatecontact/updatecontact'
import {UpdatecontacteditPage} from '../pages/updatecontactedit/updatecontactedit';
import {UpdateaddressPage} from '../pages/updateaddress/updateaddress'
import {UpdateaddresseditPage} from '../pages/updateaddressedit/updateaddressedit'
import {ForseclousrestatementsPage} from '../pages/forseclousrestatements/forseclousrestatements'
import {InterestratecertificatePage} from '../pages/interestratecertificate/interestratecertificate'
import {WelcomeletterPage} from '../pages/welcomeletter/welcomeletter'
import { FinancialdetailsPage } from '../pages/financialdetails/financialdetails';
import { CoPersonaldetailsPage } from '../pages/co-personaldetails/co-personaldetails';
import { CoFinancialdetailsPage } from '../pages/co-financialdetails/co-financialdetails';
import { LeadThankYouPage } from '../pages/lead-thank-you/lead-thank-you';
import {YourPropertyPage} from '../pages/your-property/your-property';


import {PartpaymentPage} from '../pages/partpayment/partpayment';
import {EmiempirelatedPage} from '../pages/emiempirelated/emiempirelated'
import {EmiempirelateddetailsPage} from '../pages/emiempirelateddetails/emiempirelateddetails'
import {ContactdetailsupdatePage} from '../pages/contactdetailsupdate/contactdetailsupdate'
import {UpdateladlinenumberPage} from '../pages/updateladlinenumber/updateladlinenumber'
import {UpdateofficialemailPage} from '../pages/updateofficialemail/updateofficialemail'
import {ChangeaddressesPage} from '../pages/changeaddresses/changeaddresses'
import {ThankuPage} from '../pages/thanku/thanku'
import {AddressesPage} from '../pages/addresses/addresses'
import { EditAddressPage } from '../pages/edit-address/edit-address';
import { FaqPostPage } from '../pages/faq-post/faq-post';
import { OdpaymentPage } from '../pages/odpayment/odpayment';
import { CancelMandatePage } from '../pages/cancel-mandate/cancel-mandate';

import { AppPersonalInfoPage } from '../pages/app-personal-info/app-personal-info';
import { AppLoanRequirementPage } from '../pages/app-loan-requirement/app-loan-requirement';
import {StatementsofaccountsPage} from '../pages/statementsofaccounts/statementsofaccounts'
import {ListoddocumentsPage} from '../pages/listoddocuments/listoddocuments'
import {RepaymentsschedulePage} from '../pages/repaymentsschedule/repaymentsschedule'
import { HTTP } from '@ionic-native/http';
import { OneSignal } from '@ionic-native/onesignal';



import { InterceptorProvider } from '../providers/interceptor/interceptor';
import { IonicStorageModule } from '@ionic/storage';
// import { InterceptorProvider } from '../providers/interceptor/interceptor';
 
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {FileuploadPage} from '../pages/fileupload/fileupload';
import {CalculatorsPage} from '../pages/calculators/calculators'
// import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AllInOneSdkProvider } from '../providers/all-in-one-sdk/all-in-one-sdk';
// import { AllInOneSDK } from '@ionic-native/all-in-one-sdk/ngx'
import { DirectivesIonicInputNumberDirective } from '../directives/directives-ionic-input-number/directives-ionic-input-number';
import { CcpDirective } from '../directives/ccp/ccp';

// import { InAppBrowser } from '@ionic-native/in-app-browser';

 @NgModule({
  exports:[DirectivesIonicInputNumberDirective,CcpDirective],
  declarations: [
          MyApp,AboutPage,
          ContactPage,HomePage,
          TabsPage,LoginPage,
          BranchLocatorPage,
          CalculatorPage,
          ForgotMobileNumberPage,
          FaqPage,
          IntrestRateMovementPage,
          OffersPage,
          OtherProductPage,
          PmayPage,
          ReferAFriendPage,
          PropertyDocumentListPage,
          PropertyDocumentPickupPage,
          PropertyDocumentChecklistPage,

          PasswordPage,
          OtpPage,
          CreateNewPasswordPage,
          SetNewPasswordPage,
          DashBoardPage,
          CommingSoonPage,
          AccountSummaryPage,
          PaymentsPage,
          ServiceRequestPage,
          RaisedIssuesPage,
          PersonalDetailsPage,
          InvestRateHistoryPage,
          EmiPmiPaymentsPage,
          OthersPaymentsPage,
          NewservicerequestPage,
          ServicehistoryPage,
          RaisedservicehistoryPage,
          UpdateinfoloadingsrPage,
          DocumentstatementPage,
          UpdatepersonalPage,
          UpdatepersonaleditPage,
          UpdatecontactPage,
          UpdatecontacteditPage,
          UpdateaddressPage,
          UpdateaddresseditPage,
          ForseclousrestatementsPage,
          InterestratecertificatePage,
          WelcomeletterPage,
          FinancialdetailsPage,
          CoPersonaldetailsPage,
          CoFinancialdetailsPage,
          LeadThankYouPage,
          YourPropertyPage,
          PartpaymentPage,
          EmiempirelatedPage,
          EmiempirelateddetailsPage,
          ContactdetailsupdatePage,
          UpdateladlinenumberPage,
          UpdateofficialemailPage,
          ChangeaddressesPage,
          ThankuPage,
          EditAddressPage,
          AddressesPage,
          FileuploadPage,
          FaqPostPage,
          OdpaymentPage,
          CancelMandatePage,
          CalculatorsPage,
          AppPersonalInfoPage,
          AppLoanRequirementPage,
          StatementsofaccountsPage,
          ListoddocumentsPage,
          RepaymentsschedulePage,
          DirectivesIonicInputNumberDirective,CcpDirective


  ],
  imports: [
    BrowserModule,
    HttpClientModule,

    IonicStorageModule.forRoot(),
    // IonicModule.forRoot(MyApp),
    
    IonicModule.forRoot(MyApp,{
      locationStrategy: 'path',
      menuType: 'push',
      platforms: {
        ios: {
          menuType: 'overlay',
        }
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
        MyApp,
        AboutPage,
        ContactPage,
        HomePage,
        TabsPage,
        LoginPage,
        BranchLocatorPage,
        CalculatorPage,
        ForgotMobileNumberPage,
        FaqPage,
        IntrestRateMovementPage,
        OffersPage,
        OtherProductPage,
        PmayPage,
        ReferAFriendPage,
        PropertyDocumentListPage,
        PropertyDocumentPickupPage,
        PropertyDocumentChecklistPage,
        PasswordPage,
        OtpPage,
        CreateNewPasswordPage,
        SetNewPasswordPage,
        DashBoardPage,
        CommingSoonPage,
        AccountSummaryPage,
        PaymentsPage,
        ServiceRequestPage,
        RaisedIssuesPage,
        PersonalDetailsPage,
        InvestRateHistoryPage,
        EmiPmiPaymentsPage,
        OthersPaymentsPage,
        NewservicerequestPage,
        ServicehistoryPage,
        RaisedservicehistoryPage,
        UpdateinfoloadingsrPage,
        DocumentstatementPage,
        UpdatepersonalPage,
        UpdatepersonaleditPage,
        UpdatecontactPage,
        UpdatecontacteditPage,
        UpdateaddressPage,
        UpdateaddresseditPage,
        ForseclousrestatementsPage,
        InterestratecertificatePage,
        WelcomeletterPage,
        FinancialdetailsPage,
        CoPersonaldetailsPage,
        CoFinancialdetailsPage,
        LeadThankYouPage,
        YourPropertyPage,
        PartpaymentPage,
        EmiempirelatedPage,
        EmiempirelateddetailsPage,
        ContactdetailsupdatePage,
        UpdateladlinenumberPage,
        UpdateofficialemailPage,
        ChangeaddressesPage,
        ThankuPage,
        EditAddressPage,
        AddressesPage,
        FileuploadPage,
        FaqPostPage,
        OdpaymentPage,
        CancelMandatePage,
        CalculatorsPage,
        AppPersonalInfoPage,
        AppLoanRequirementPage,
        StatementsofaccountsPage,
        ListoddocumentsPage,
        RepaymentsschedulePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    CommonProvider,
    GenericFormValidationProvider,
    OneSignal,
    InterceptorProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true },
    // InAppBrowser,
    AllInOneSdkProvider,
    HTTP
    // AllInOneSDK,
    
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts